import React, { useRef, useState } from 'react';
import { Upload } from '@mui/icons-material';
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';
import { Box, InputAdornment } from '@mui/material';
import DialogLoading from '../../../../components/feedback/DialogLoading';
import AppButton from '../../../../components/ui/AppButton';
import AppInput from '../../../../components/ui/AppInput';
import { useShippingORC } from '../../../../hooks/useShipping';
import ORCDialog from './ORCDialog';

const SearchFilter = ({ search, onSearchChange, handleSearch, handleDownload }) => {
  const inputRef = useRef(null);
  const [OCRData, setOCRData] = useState([]);
  const [OCRDialog, setOCRDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const { mutateAsync: shippingORC } = useShippingORC();

  const handleUploadFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('bill', file);

    try {
      setLoading(true);
      const response = await shippingORC({ dto: formData });

      if (response.Code === '20000') {
        setOCRData(response.Data);
        setOCRDialog(true);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      e.target.value = '';
    }
  };

  return (
    <>
      <Box
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          marginBottom: '20px',
          [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
          },
        })}
      >
        {/* Search */}
        <Box display="flex" alignItems="center" gap={1} sx={{ maxWidth: 500, width: '100%' }}>
          <AppInput
            placeholder="ค้นหารหัสบริษัท"
            autoComplete="off"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#004B61' }} />
                </InputAdornment>
              ),
            }}
          />
          <AppButton variant="dangerStrong" onClick={handleSearch}>
            ค้นหา
          </AppButton>
        </Box>
        {/* Actions */}
        <Box
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}
        >
          <AppButton variant="brand" onClick={() => inputRef.current.click()}>
            <DownloadIcon sx={{ fontSize: '1rem', display: 'inline-block', marginRight: '5px' }} />
            Import Tracking
            <input
              ref={inputRef}
              type="file"
              name="uploadFile"
              onChange={handleUploadFile}
              hidden
            />
          </AppButton>
          <AppButton variant="dangerStrong" onClick={handleDownload}>
            <Upload sx={{ fontSize: '1rem', display: 'inline-block', marginRight: '5px' }} />
            Export Excel
          </AppButton>
        </Box>
      </Box>
      {/* OCR Dialog */}
      <ORCDialog open={OCRDialog} onClose={() => setOCRDialog(false)} OCRData={OCRData} />
      {/* Loading Dialog */}
      <DialogLoading open={loading} onClose={() => setLoading(false)} message="กำลังโหลดข้อมูล" />
    </>
  );
};

export default React.memo(SearchFilter);
